
export default {
  data() {
    return {
      activeIndex: 0,
      options: [
        {
          name: "question",
          label: this.$t("text.question"),
          type: "text",
        },
        {
          name: "answer",
          label: this.$t("text.answer"),
          type: "tipTap",
        },
      ],
    };
  },

  methods: {
    toogleQuestion(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else this.activeIndex = index;
    },
  },
};
